import React, { createContext, useEffect, useReducer, useState } from "react";
import { API, API_C2S, API_HADES, auth, database } from "shared/services";

import * as types from "./store/types";
import { reducer, defaultState } from "./store";
import { loadTags } from "modules/app/utils/http/tags";

const MainStateContext = createContext();
const MainDispatchContext = createContext();
let firstChild = false;

function MainContext({ children }) {
  const [state, dispatch] = useReducer(reducer, {
    defaultState,
  });
  const [finishWait, setFinishWait] = useState(false);
  const [forwardMode, setForwardMode] = useState(false);
  const [selectedForwardContacts, setSelectedForwardContacts] = useState([]);
  const [tags, setTags] = useState([]);
  const currentUser = auth.currentUser;
  const reference = database.ref(`customers/${currentUser?.uid}`);

  async function initialLoadTags() {
    try {
      const data = await loadTags();
      const visibleTags = data.filter((tag) => tag.visible);
      setTags(visibleTags);
    } catch (error) {
      console.log(error);
    }
  }

  useEffect(() => {
    auth.onAuthStateChanged((user) => {
      async function loadGeneralInfos() {
        if (!auth) return;
        try {
          const result = await API.get("info_for_create");
          const { data } = result;
          const {
            company,
            users,
            lead_sources,
            channels,
            id,
            jwt_token,
          } = data;

          const user = users.find((user) => user?.id == id);

          API_C2S.defaults.headers.common.Authorization = `Bearer ${jwt_token}`;
          API_HADES.defaults.headers.common.Authorization = `Bearer ${jwt_token}`;
          localStorage.setItem("jwt_token", jwt_token);

          if (user?.status == "disabled") {
            await auth.signOut();
            history.push("/");
          }

          if (user && user?.status != "disabled") {
            dispatch({
              type: types.UPDATE_MAIN,
              data: {
                ...defaultState,
                leadSources: lead_sources,
                channels: channels,
                users: users,
                user: user,
                company: {
                  ...company,
                  company_teams: company.company_teams.map((team) => {
                    const my_users = [];

                    users.forEach(
                      (user) =>
                        user.company_team_ids.includes(team?.id) &&
                        my_users.push(user?.id)
                    );

                    return { ...team, users: my_users };
                  }),
                },
              },
            });
          }
        } catch (e) {
          console.log(e);
        }

        setFinishWait(true);
      }
      if (user) {
        loadGeneralInfos();
        initialLoadTags();
      }
    });

    return () => {
      auth.onAuthStateChanged(() => {});
    };
  }, []);

  useEffect(() => {
    if (selectedForwardContacts?.length > 0) {
      setForwardMode(true);
    }
    if (selectedForwardContacts?.length === 0) {
      setForwardMode(false);
    }
  }, [selectedForwardContacts]);

  useEffect(() => {
    reference
      .orderByChild("updated_at")
      .limitToLast(1)
      .on("child_added", (data) => {
        if (firstChild) {
          dispatch({
            type: types.ADD_CONTACT_FROM_LIST,
            contact: data.val(),
          });
        }

        firstChild = true;
      });

    reference.on("child_removed", (data) => {
      dispatch({
        type: types.REMOVE_CONTACT_FROM_LIST,
        contact: data.val(),
      });
    });

    reference.on("child_changed", (data) => {
      dispatch({
        type: types.UPDATE_CONTACT_FROM_LIST,
        contact: data.val(),
      });
    });

    return () => {
      reference.off();
    };
  }, []);

  return !!finishWait ? (
    <MainStateContext.Provider
      value={{
        ...state,
        forwardMode,
        setForwardMode,
        tags,
        selectedForwardContacts,
        setSelectedForwardContacts,
      }}
    >
      <MainDispatchContext.Provider value={dispatch}>
        {children}
      </MainDispatchContext.Provider>
    </MainStateContext.Provider>
  ) : (
    <></>
  );
}

export { MainContext, MainStateContext, MainDispatchContext };
